module.exports = __webpack_public_path__ + "img/we-are-hiring-dark.9a6e5862.svg";